export default "__VITE_ASSET__BtY1w7y9__"